import {ReadyProvider} from '../../../application/providers/readyProvider';
import {BaseTabs} from '../../../application/baseTabs';
import {VerificationForm} from './forms/verificationForm';
import {SocialLoginButtons} from '../../../application/socialLoginButtons';

ReadyProvider.executeOnReady(() => {
    let verificationTabsElement = document.querySelector('[data-content="verification-tabs"]');

    if (verificationTabsElement) {
        new BaseTabs(verificationTabsElement);
        new VerificationForm(document.querySelector('[data-form="mail-verification"]'));
        new VerificationForm(document.querySelector('[data-form="recomended-verification"]'));
        new VerificationForm(document.querySelector('[data-form="alternative-verification"]'));
    }
});

ReadyProvider.executeWithLazy(() => {
    SocialLoginButtons.init();
});
